module.exports = __webpack_public_path__ + "static/salon-b754cc7f81c93ba9bf4552483d1bd68a-min-616155bbefc682d818a15803b8ee9a93.jpg";